import { Link } from "react-router-dom";
import { categories, entries } from "@/mocks/entries";

export default function CategoryGrid() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100 px-4 py-14 md:px-10 md:py-20">
      <div className="mb-10 max-w-3xl md:mb-14">
        <span className="font-heading text-sm font-bold tracking-[0.2em] text-secondary-600">
          TOPIC INDEX
        </span>
        <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
          按话题找到你想看的事件
        </h2>
        <p className="mt-4 text-base leading-relaxed text-foreground-600">
          六个长期更新的分类，覆盖娱乐、饭圈、直播电竞、达人创作、商业消费与演出综艺。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = entries.filter((e) => e.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/entries?cat=${cat.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300 md:p-6"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-secondary-50">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-secondary-700">
                  {cat.name}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.intro}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-foreground-500">
                  {count > 0 ? `${count} 条词条` : "持续收录中"}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}